import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-listing',
  standalone: true,
  imports: [CommonModule,MatIconModule],
  templateUrl: './listing.component.html',
  styleUrl: './listing.component.css'
})
export class ListingComponent {

  constructor(private router:Router){}

  activeTab: string = 'items'; // Default active tab

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }
  navigateTo() {
    this.router.navigate(['/create-rfi']);
    }
}
